function veda_fn_id_88925b2a008746f49ac4882406613a65() {
    
    try {
      const uniqueId = /* _____Start/Id_____ */"id_88925b2a-0087-46f4-9ac4-882406613a65"/* _____End/Id_____ */;
      const containers = document.querySelectorAll(`[data-id="${uniqueId}"]:not(addons, megamenu)`);
      containers.forEach(container => {
        if (!container) {
          return;
        }
        veda.plugins.videoCover(container);
        /* _____Start/Content_____ */
        const { interpolate } = veda.utils;
const barEl = container.querySelector(".bar-js");
const OFFSET = 200;

function handler() {
  if (window.scrollY > OFFSET) {
    container.style.opacity = "1";
    container.style.visibility = "visible";
    container.style.transform = "translateY(0)";
  } else {
    container.style.removeProperty("opacity");
    container.style.removeProperty("visibility");
    container.style.removeProperty("transform");
  }
  const val = interpolate({
    value: window.scrollY,
    inputRange: [OFFSET, document.body.offsetHeight - window.innerHeight],
    outputRange: [125, 0],
  });
  barEl.style.strokeDashoffset = val;

  const tabNavigatorEl = document.querySelector(".veda-tab-navigator");
  if (!!tabNavigatorEl) {
    container.style.marginBottom = `${tabNavigatorEl.offsetHeight}px`;
  }
}

function handleScrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

handler();
window.addEventListener("scroll", handler);
container.addEventListener("click", handleScrollToTop);

onCleanup(() => {
  window.removeEventListener("scroll", handler);
  container.removeEventListener("click", handleScrollToTop);
});


        /* _____End/Content_____ */
      });
    } catch (error) {
      console.log(error);
    }
  };
veda_fn_id_88925b2a008746f49ac4882406613a65();
